"use client";

import { TArticleGridSection } from "@shared/types";
import { SectionHeading } from "@shared/ui";
import { ArticleCard } from "@shared/ui/article-card";

export function ArticleGridSection({ title, articles, category }: TArticleGridSection) {
  return (
    <section className="pt-20 pb-20 sm:pb-[100px] md:pb-[120px] relative bg-white">
      <div className="container relative">
        <SectionHeading className="text-center" title={title} titleClassName="max-w-2xl" descriptionClassName="max-w-3xl mx-auto" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-[60px] sm:gap-x-6 lg:gap-x-9 mt-6 lg:mt-10">
          {articles?.data?.map((article) => (
            <ArticleCard
              key={article.id}
              article={article.attributes}
              category={category}
              buttonVariant="link"
              imageClassName="h-[206px] sm:h-[220px] md:h-[240px]"
            />
          ))}
        </div>
      </div>
    </section>
  );
}
